import { render, staticRenderFns } from "./AppJsonList.vue?vue&type=template&id=06b5e7cf&scoped=true&"
import script from "./AppJsonList.vue?vue&type=script&lang=js&"
export * from "./AppJsonList.vue?vue&type=script&lang=js&"
import style0 from "./AppJsonList.vue?vue&type=style&index=0&id=06b5e7cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5e7cf",
  null
  
)

export default component.exports